import React, { useContext, useEffect, useMemo, useState } from 'react'



import { SocketContext } from '../context/SocketContext'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'


const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
}

export const InformeTicketHoy = () => {


    const { socket } = useContext( SocketContext );

    const [ atencionPromedio, setAtencionPromedio ] = useState([]);
    
    const [ fechaInicio ] = useState( formatDate(new Date()) );
    const [ fechaFinal ] = useState( formatDate(new Date()) );

    let [usuario] = useState( getUsuarioStorage() );
    const entidad = usuario.entidad;

     // tabla
    const datos= useMemo(() =>{
        return {
            entidad
        }
    }, [entidad])

    useEffect(() => {
        async function fetchAtencionesPromedio() {
            datos.fechaInicio= fechaInicio;
            datos.fechaFinal= fechaFinal;
            await socket.emit('atenciones-Promedio', datos, ( lista ) => {
                setAtencionPromedio( lista[0] )
            })
        }

        fetchAtencionesPromedio();

        socket.on('atenciones-Promedio', datos, ( lista ) => {
            setAtencionPromedio( lista[0] )
        })
               
        return () => {
            socket.off('atenciones-Promedio')
        }
    }, [ socket, fechaFinal, fechaInicio, datos ])
    

    useEffect(() => {
        socket.on('atenciones-Promedio-a', ( lista ) => {
            setAtencionPromedio( lista[0] )
        })
               
        return () => {
            socket.off('atenciones-Promedio-a')
        }
    }, [ socket ])
    

  return (
    <div className='container'>

            <div className='row'>

                <div className='mt-3 col-xxl-2 col-md-6 col-12' >
                    <div className="card col-12 text-bg-primary" style={{ maxHeight: '123.976px' }} >
                        <div className="row g-0">
                            
                            <div className="card-body">
                                <div className='inner'>
                                    <h2 style={{ fontSize: "2.5rem", fontWeight: "bolder" }}>{ atencionPromedio.cantidad | 0 }</h2>
                                </div>

                                
                                <div className="icon" >
                                    <i className="fa-solid fa-chart-line" style={{ color: "rgba(0,0,0,.15)",  position: "absolute", right: "15px", fontSize: "70px", top: "20px" }}></i>
                                </div>
                                <p className="card-text"><small style={{color: "white" }}>Tickets Solicitados Hoy</small></p>
                            </div>
                            
                        </div>
                    </div>
                </div>                                
                
                <div className='mt-3 col-xxl-2 col-md-6 col-12'>
                    <div className="card col-12 text-bg-success" style={{ maxHeight: '123.976px' }}  >
                        <div className="row g-0">
                            
                            <div className="card-body">
                                <div className='inner'>
                                    <h2 style={{ fontSize: "2.5rem", fontWeight: "bolder" }}> { atencionPromedio.promedioLLamado === null ? 0 : atencionPromedio.promedioLLamado }</h2>
                                </div>

                                
                                <div className="icon" >
                                    <i className="fa-solid fa-clock" style={{ color: "rgba(0,0,0,.15)",  position: "absolute", right: "15px", fontSize: "70px", top: "20px" }}></i>
                                </div>
                                <p className="card-text"><small style={{color: "white" }}>Tiempo Promedio en Llamado</small></p>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className='mt-3 col-xxl-2 col-md-6 col-12'>
                    <div className="card col-12 text-bg-danger" style={{ maxHeight: '123.976px' }} >
                        <div className="row g-0">
                            
                            <div className="card-body">
                                <div className='inner'>
                                    <h2 style={{ fontSize: "2.5rem", fontWeight: "bolder" }}> { atencionPromedio.promedioAtencion === null  ? 0 : atencionPromedio.promedioAtencion }</h2>
                                </div>

                                
                                <div className="icon" >
                                    <i className="fa-solid fa-user-clock" style={{ color: "rgba(0,0,0,.15)",  position: "absolute", right: "15px", fontSize: "70px", top: "20px" }}></i>
                                </div>
                                <p className="card-text"><small style={{color: "white" }}>Tiempo Promedio en Atención</small></p>
                            </div>
                            
                        </div>
                    </div>
                </div>

              
            </div>
    </div>
  )
}
